import { useId } from "react";
import { isSolanaAddress, solanaPayUrl } from "@shared/solana/address";
import { SITE } from "@shared/site/site-config";
import { ModalDialog } from "../../platform/ui/ModalDialog";
import { AddressField } from "./AddressField";
import { SolanaQr } from "./SolanaQr";
import { useDonatePanel } from "./useDonatePanel";
import "./donate.css";

/** Orla's Solana address as a scannable code and as text. Mounted once, in the site layout. */
export function DonateDialog() {
  const panel = useDonatePanel();
  const titleId = useId();
  const { address, walletLabel, network } = SITE.donation;

  // The build already refuses a malformed address; this keeps a bad one from ever being shown.
  if (!isSolanaAddress(address)) return null;
  const payUrl = solanaPayUrl(address, walletLabel);

  return (
    <ModalDialog
      open={panel.isOpen}
      onClose={panel.close}
      labelledBy={titleId}
      placement="centre"
      width={38}
    >
      <div className="donate-dialog">
        <header className="donate-dialog__header">
          <h2 id={titleId} className="donate-dialog__title">
            Donate to Orla
          </h2>
          <button type="button" className="donate-dialog__close" onClick={panel.close}>
            Close
          </button>
        </header>
        <p className="donate-dialog__lead">
          This is Orla&rsquo;s personal wallet on {network}. Scan the code with a {network} wallet,
          or copy the address.
        </p>
        <div className="donate-dialog__body">
          <SolanaQr value={payUrl} label={`QR code for Orla's ${network} address`} />
          <div className="donate-dialog__details">
            <p className="donate-dialog__label">{network} address</p>
            <AddressField address={address} />
            <a className="donate-dialog__wallet" href={payUrl}>
              Open in a wallet on this device
            </a>
          </div>
        </div>
        <p className="donate-dialog__caution">
          Check that the address in your wallet matches this one, character for character, before
          you send. Transfers on {network} cannot be reversed, and this address can only receive SOL
          and tokens on the {network} network.
        </p>
      </div>
    </ModalDialog>
  );
}
